// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/requestcatalog/v1/requestcatalogmanagement.proto" (package "c1.api.requestcatalog.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { UserRef } from "../../user/v1/user";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { User } from "../../user/v1/user";
import { AppEntitlementView } from "../../app/v1/app_entitlement";
import { AppEntitlementExpandMask } from "../../app/v1/app_entitlement";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { RequestCatalog } from "./requestcatalog";
import { RequestCatalogUnenrollmentEntitlementBehavior } from "./requestcatalog";
import { RequestCatalogUnenrollmentBehavior } from "./requestcatalog";
import { RequestCatalogEnrollmentBehavior } from "./requestcatalog";
import { Any } from "../../../../google/protobuf/any";
import { RequestCatalogView } from "./requestcatalog";
import { RequestCatalogExpandMask } from "./requestcatalog";
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequest
 */
export interface RequestCatalogManagementServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 2
     */
    expandMask?: RequestCatalogExpandMask;
}
/**
 * The request catalog management service get response returns a request catalog view with the expanded items in the expanded array indicated by the expand mask in the request.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetResponse
 */
export interface RequestCatalogManagementServiceGetResponse {
    /**
     * A view of the request catalog, contains the serialized user and paths to objects referenced by the request catalog.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogView request_catalog_view = 1
     */
    requestCatalogView?: RequestCatalogView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * Create a request catalog.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequest
 */
export interface RequestCatalogManagementServiceCreateRequest {
    /**
     * The display name of the new request catalog.
     *
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * The description of the new request catalog.
     *
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * The expand mask includes the paths in the catalog view to expand in the return value of this call.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 4
     */
    expandMask?: RequestCatalogExpandMask;
    /**
     * Whether or not the new catalog should be created as published.
     *
     * @generated from protobuf field: bool published = 5
     */
    published: boolean;
    /**
     * Whether or not the new catalog is visible to everyone by default.
     *
     * @generated from protobuf field: bool visible_to_everyone = 6
     */
    visibleToEveryone: boolean;
    /**
     * Whether all the entitlements in the catalog can be requests at once. Your tenant must have the bundles feature to use this.
     *
     * @generated from protobuf field: bool request_bundle = 7
     */
    requestBundle: boolean;
    /**
     * Defines how to handle the request policies of the entitlements in the catalog during enrollment.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior enrollment_behavior = 8
     */
    enrollmentBehavior: RequestCatalogEnrollmentBehavior;
    /**
     * Defines how to handle the revocation of the entitlements in the catalog during unenrollment.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior unenrollment_behavior = 9
     */
    unenrollmentBehavior: RequestCatalogUnenrollmentBehavior;
    /**
     * Defines how to handle the revoke policies of the entitlements in the catalog during unenrollment.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior unenrollment_entitlement_behavior = 10
     */
    unenrollmentEntitlementBehavior: RequestCatalogUnenrollmentEntitlementBehavior;
}
/**
 * Update a request catalog object by ID.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateRequest
 */
export interface RequestCatalogManagementServiceUpdateRequest {
    /**
     * The request catalog to update values with.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalog catalog = 1
     */
    catalog?: RequestCatalog;
    /**
     * The update mask is a comma-separated list of strings indicating what fields to update the request catalog with.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
    /**
     * The expand mask includes the paths in the catalog view to expand in the return value of this call.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 3
     */
    expandMask?: RequestCatalogExpandMask;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListRequest
 */
export interface RequestCatalogManagementServiceListRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The page_token field for pagination.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Control the array of expanded values that are filled out in the response to this request.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 3
     */
    expandMask?: RequestCatalogExpandMask;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListResponse
 */
export interface RequestCatalogManagementServiceListResponse {
    /**
     * The list of request catalogs.
     *
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogView list = 1
     */
    list: RequestCatalogView[];
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * The RequestCatalogManagementServiceAddAppEntitlementsRequest object is used to add app requestable app entitlements to a request catalog.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAppEntitlementsRequest
 */
export interface RequestCatalogManagementServiceAddAppEntitlementsRequest {
    /**
     * The Id of the request catalog to add app entitlements to. This is a URL value.
     *
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * List of entitlements to add to the request catalog.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 2
     */
    appEntitlements: AppEntitlementRef[];
    /**
     * Whether or not to create requests for newly added entitlements for users in the catalog.
     * By default, this is false and no requests are created.
     *
     * @generated from protobuf field: bool create_requests = 3
     */
    createRequests: boolean;
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAppEntitlementsResponse
 */
export interface RequestCatalogManagementServiceAddAppEntitlementsResponse {
}
/**
 * The RequestCatalogManagementServiceUpdateAppEntitlementsRequest object is used to update app entitlements to a request catalog id.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateAppEntitlementsRequest
 */
export interface RequestCatalogManagementServiceUpdateAppEntitlementsRequest {
    /**
     * The Id of the request catalog to get app entitlement to. This is a URL value.
     *
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * The entitlement to get from the request catalog.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 2
     */
    appEntitlements: AppEntitlementRef[];
}
/**
 * The RequestCatalogManagementServiceUpdateAppEntitlementsResponse object is is the response from UpdateAppEntitlements endpoint.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateAppEntitlementsResponse
 */
export interface RequestCatalogManagementServiceUpdateAppEntitlementsResponse {
}
/**
 * The RequestCatalogManagementServiceRemoveAppEntitlementsRequest message is used to remove app entitlements from a request catalog.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAppEntitlementsRequest
 */
export interface RequestCatalogManagementServiceRemoveAppEntitlementsRequest {
    /**
     * The catalogId for the catalog to remove entitlements from.
     *
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * The list of app entitlements to remove from the catalog.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 2
     */
    appEntitlements: AppEntitlementRef[];
}
/**
 * Empty response with a status code indicating success
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAppEntitlementsResponse
 */
export interface RequestCatalogManagementServiceRemoveAppEntitlementsResponse {
}
// Individual Requestable Entry Management Messages

/**
 * Create a single requestable entry
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequestableEntryRequest
 */
export interface RequestCatalogManagementServiceCreateRequestableEntryRequest {
    /**
     * The ID of the access profile (catalog) to add the entitlement to
     *
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * The ID of the app that contains the entitlement
     *
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * The ID of the entitlement to add to the request catalog
     *
     * @generated from protobuf field: string entitlement_id = 3
     */
    entitlementId: string;
    /**
     * Whether or not to create requests for newly added entitlement for users in the catalog.
     * By default, this is false and no requests are created.
     *
     * @generated from protobuf field: bool create_requests = 4
     */
    createRequests: boolean;
}
/**
 * A requestable entry in a catalog
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestableEntry
 */
export interface RequestableEntry {
    /**
     * The ID of the access profile (catalog)
     *
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * The ID of the app that contains the entitlement
     *
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * The ID of the entitlement
     *
     * @generated from protobuf field: string entitlement_id = 3
     */
    entitlementId: string;
}
/**
 * Response containing the created requestable entry
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequestableEntryResponse
 */
export interface RequestCatalogManagementServiceCreateRequestableEntryResponse {
    /**
     * The created requestable entry
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestableEntry requestable_entry = 1
     */
    requestableEntry?: RequestableEntry;
}
/**
 * Get a single requestable entry
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequestableEntryRequest
 */
export interface RequestCatalogManagementServiceGetRequestableEntryRequest {
    /**
     * The ID of the access profile (catalog)
     *
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * The ID of the app that contains the entitlement
     *
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * The ID of the entitlement
     *
     * @generated from protobuf field: string entitlement_id = 3
     */
    entitlementId: string;
}
/**
 * Response containing the requested entry
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequestableEntryResponse
 */
export interface RequestCatalogManagementServiceGetRequestableEntryResponse {
    /**
     * The requested entry
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestableEntry requestable_entry = 1
     */
    requestableEntry?: RequestableEntry;
}
/**
 * Delete a single requestable entry
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequestableEntryRequest
 */
export interface RequestCatalogManagementServiceDeleteRequestableEntryRequest {
    /**
     * The ID of the access profile (catalog)
     *
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * The ID of the app that contains the entitlement
     *
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * The ID of the entitlement
     *
     * @generated from protobuf field: string entitlement_id = 3
     */
    entitlementId: string;
}
/**
 * Empty response for delete operation
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequestableEntryResponse
 */
export interface RequestCatalogManagementServiceDeleteRequestableEntryResponse {
}
/**
 * The RequestCatalogManagementServiceAddAccessEntitlementsRequest message is used to add access entitlements to a request
 * catalog to determine which users can view the request catalog.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAccessEntitlementsRequest
 */
export interface RequestCatalogManagementServiceAddAccessEntitlementsRequest {
    /**
     * The Id of the request catalog to add access entitlements to. This is a URL value.
     *
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * List of entitlements to add to the request catalog as access entitlements.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef access_entitlements = 2
     */
    accessEntitlements: AppEntitlementRef[];
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAccessEntitlementsResponse
 */
export interface RequestCatalogManagementServiceAddAccessEntitlementsResponse {
}
/**
 * The RequestCatalogManagementServiceRemoveAccessEntitlementsRequest message is used to remove access entitlements from a request catalog.
 * The access entitlements are used to determine which users can view the request catalog.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAccessEntitlementsRequest
 */
export interface RequestCatalogManagementServiceRemoveAccessEntitlementsRequest {
    /**
     * The catalogId for the catalog to remove access entitlements from.
     *
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * The list of access entitlements to remove from the catalog.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef access_entitlements = 2
     */
    accessEntitlements: AppEntitlementRef[];
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAccessEntitlementsResponse
 */
export interface RequestCatalogManagementServiceRemoveAccessEntitlementsResponse {
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerCatalogRequest
 */
export interface RequestCatalogManagementServiceListEntitlementsPerCatalogRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * The RequestCatalogManagementServiceListEntitlementsPerCatalogResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerCatalogResponse
 */
export interface RequestCatalogManagementServiceListEntitlementsPerCatalogResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1
     */
    list: AppEntitlementView[];
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest
 */
export interface RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse
 */
export interface RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef refs = 1
     */
    refs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerAppRequest
 */
export interface RequestCatalogManagementServiceListEntitlementsPerAppRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerAppResponse
 */
export interface RequestCatalogManagementServiceListEntitlementsPerAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1
     */
    list: AppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsForAccessRequest
 */
export interface RequestCatalogManagementServiceListEntitlementsForAccessRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * The RequestCatalogManagementServiceListEntitlementsForAccessResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsForAccessResponse
 */
export interface RequestCatalogManagementServiceListEntitlementsForAccessResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1
     */
    list: AppEntitlementView[];
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * Delete a request catalog by Id. It uses URL value for input.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequest
 */
export interface RequestCatalogManagementServiceDeleteRequest {
    /**
     * The Id of the RequestCatalog to delete.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteResponse
 */
export interface RequestCatalogManagementServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnerExpandMask
 */
export interface RequestCatalogOwnerExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceListRequest
 */
export interface RequestCatalogOwnersServiceListRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogOwnerExpandMask expand_mask = 4
     */
    expandMask?: RequestCatalogOwnerExpandMask;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwner
 */
export interface RequestCatalogOwner {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnerView
 */
export interface RequestCatalogOwnerView {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogOwner request_catalog_owner = 1
     */
    requestCatalogOwner?: RequestCatalogOwner;
    /**
     * @generated from protobuf field: string user_path = 2
     */
    userPath: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceListResponse
 */
export interface RequestCatalogOwnersServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogOwnerView list = 1
     */
    list: RequestCatalogOwnerView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceAddRequest
 */
export interface RequestCatalogOwnersServiceAddRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1
     */
    requestCatalogId: string;
    /**
     * @generated from protobuf field: string user_id = 2
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceAddResponse
 */
export interface RequestCatalogOwnersServiceAddResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 1
     */
    user?: User;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceRemoveRequest
 */
export interface RequestCatalogOwnersServiceRemoveRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1
     */
    requestCatalogId: string;
    /**
     * @generated from protobuf field: string user_id = 2
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceRemoveResponse
 */
export interface RequestCatalogOwnersServiceRemoveResponse {
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogRef
 */
export interface RequestCatalogRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAutomationLastRunState
 */
export interface BundleAutomationLastRunState {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_run_at = 1
     */
    lastRunAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationRunStatus status = 2
     */
    status: BundleAutomationRunStatus;
    /**
     * @generated from protobuf field: string error_message = 3
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement
 */
export interface BundleAutomationRuleEntitlement {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 1
     */
    entitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SetBundleAutomationRequest
 */
export interface SetBundleAutomationRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1
     */
    requestCatalogId: string;
    /**
     * @generated from protobuf oneof: conditions
     */
    conditions: {
        oneofKind: "entitlements";
        /**
         * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement entitlements = 101
         */
        entitlements: BundleAutomationRuleEntitlement;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool enabled = 2
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: bool create_tasks = 3
     */
    createTasks: boolean;
    /**
     * @generated from protobuf field: bool disable_circuit_breaker = 4
     */
    disableCircuitBreaker: boolean;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAutomationRef
 */
export interface BundleAutomationRef {
    /**
     * @generated from protobuf field: string request_catalog_id = 1
     */
    requestCatalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAutomationCircuitBreaker
 */
export interface BundleAutomationCircuitBreaker {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationCircuitBreakerState state = 1
     */
    state: BundleAutomationCircuitBreakerState;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserRef user_ref = 2
     */
    userRef?: UserRef;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: int64 removed_members_threshold_percentage = 4
     */
    removedMembersThresholdPercentage: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAutomation
 */
export interface BundleAutomation {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string request_catalog_id = 2
     */
    requestCatalogId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationLastRunState state = 6
     */
    state?: BundleAutomationLastRunState;
    /**
     * Change to CEL once CEL supports grants
     *
     * @generated from protobuf oneof: conditions
     */
    conditions: {
        oneofKind: "entitlements";
        /**
         * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement entitlements = 101
         */
        entitlements: BundleAutomationRuleEntitlement;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool enabled = 7
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: bool create_tasks = 8
     */
    createTasks: boolean;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationCircuitBreaker circuit_breaker = 9
     */
    circuitBreaker?: BundleAutomationCircuitBreaker;
    /**
     * @generated from protobuf field: bool disable_circuit_breaker = 10
     */
    disableCircuitBreaker: boolean;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.GetBundleAutomationRequest
 */
export interface GetBundleAutomationRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1
     */
    requestCatalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BulkGetBundleAutomationsRequest
 */
export interface BulkGetBundleAutomationsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogRef request_catalog_refs = 1
     */
    requestCatalogRefs: RequestCatalogRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BulkGetBundleAutomationsResponse
 */
export interface BulkGetBundleAutomationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.BundleAutomation list = 1
     */
    list: BundleAutomation[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.ForceRunBundleAutomationRequest
 */
export interface ForceRunBundleAutomationRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1
     */
    requestCatalogId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef refs = 2
     */
    refs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.ForceRunBundleAutomationResponse
 */
export interface ForceRunBundleAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.ResumePausedBundleAutomationRequest
 */
export interface ResumePausedBundleAutomationRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1
     */
    requestCatalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.ResumePausedBundleAutomationResponse
 */
export interface ResumePausedBundleAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.DeleteBundleAutomationRequest
 */
export interface DeleteBundleAutomationRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1
     */
    requestCatalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.DeleteBundleAutomationResponse
 */
export interface DeleteBundleAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.CreateBundleAutomationRequest
 */
export interface CreateBundleAutomationRequest {
    /**
     * @generated from protobuf field: string request_catalog_id = 1
     */
    requestCatalogId: string;
    /**
     * @generated from protobuf oneof: conditions
     */
    conditions: {
        oneofKind: "entitlements";
        /**
         * @generated from protobuf field: c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement entitlements = 101
         */
        entitlements: BundleAutomationRuleEntitlement;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool enabled = 3
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: bool create_tasks = 4
     */
    createTasks: boolean;
    /**
     * @generated from protobuf field: bool disable_circuit_breaker = 5
     */
    disableCircuitBreaker: boolean;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.CreateAppDefaultCatalogRequest
 */
export interface CreateAppDefaultCatalogRequest {
    /**
     * The app id for which this catalog is the default catalog.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * Whether or not the new catalog should be created as published.
     *
     * @generated from protobuf field: bool published = 5
     */
    published: boolean;
    /**
     * Whether or not the new catalog is visible to everyone by default.
     *
     * @generated from protobuf field: bool visible_to_everyone = 6
     */
    visibleToEveryone: boolean;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 2
     */
    expandMask?: RequestCatalogExpandMask;
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.BundleAutomationRunStatus
 */
export enum BundleAutomationRunStatus {
    /**
     * @generated from protobuf enum value: BUNDLE_AUTOMATION_RUN_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: BUNDLE_AUTOMATION_RUN_STATUS_SUCCESS = 1;
     */
    SUCCESS = 1,
    /**
     * @generated from protobuf enum value: BUNDLE_AUTOMATION_RUN_STATUS_FAILURE = 2;
     */
    FAILURE = 2,
    /**
     * @generated from protobuf enum value: BUNDLE_AUTOMATION_RUN_STATUS_IN_PROGRESS = 3;
     */
    IN_PROGRESS = 3,
    /**
     * @generated from protobuf enum value: BUNDLE_AUTOMATION_RUN_STATUS_WAITING_FOR_APPROVAL = 4;
     */
    WAITING_FOR_APPROVAL = 4
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.BundleAutomationCircuitBreakerState
 */
export enum BundleAutomationCircuitBreakerState {
    /**
     * @generated from protobuf enum value: CIRCUIT_BREAKER_STATE_UNSPECIFIED = 0;
     */
    CIRCUIT_BREAKER_STATE_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CIRCUIT_BREAKER_STATE_TRIGGERED = 1;
     */
    CIRCUIT_BREAKER_STATE_TRIGGERED = 1,
    /**
     * @generated from protobuf enum value: CIRCUIT_BREAKER_STATE_BYPASS = 2;
     */
    CIRCUIT_BREAKER_STATE_BYPASS = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceGetRequest$Type extends MessageType<RequestCatalogManagementServiceGetRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => RequestCatalogExpandMask }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile" } }] } });
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceGetRequest>): RequestCatalogManagementServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceGetRequest): RequestCatalogManagementServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask */ 2:
                    message.expandMask = RequestCatalogExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 2; */
        if (message.expandMask)
            RequestCatalogExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequest
 */
export const RequestCatalogManagementServiceGetRequest = new RequestCatalogManagementServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceGetResponse$Type extends MessageType<RequestCatalogManagementServiceGetResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetResponse", [
            { no: 1, name: "request_catalog_view", kind: "message", T: () => RequestCatalogView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceGetResponse>): RequestCatalogManagementServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceGetResponse): RequestCatalogManagementServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.requestcatalog.v1.RequestCatalogView request_catalog_view */ 1:
                    message.requestCatalogView = RequestCatalogView.internalBinaryRead(reader, reader.uint32(), options, message.requestCatalogView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.requestcatalog.v1.RequestCatalogView request_catalog_view = 1; */
        if (message.requestCatalogView)
            RequestCatalogView.internalBinaryWrite(message.requestCatalogView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetResponse
 */
export const RequestCatalogManagementServiceGetResponse = new RequestCatalogManagementServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceCreateRequest$Type extends MessageType<RequestCatalogManagementServiceCreateRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => RequestCatalogExpandMask },
            { no: 5, name: "published", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "visible_to_everyone", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "request_bundle", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "enrollment_behavior", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior", RequestCatalogEnrollmentBehavior, "REQUEST_CATALOG_ENROLLMENT_BEHAVIOR_"] },
            { no: 9, name: "unenrollment_behavior", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior", RequestCatalogUnenrollmentBehavior, "REQUEST_CATALOG_UNENROLLMENT_BEHAVIOR_"] },
            { no: 10, name: "unenrollment_entitlement_behavior", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior", RequestCatalogUnenrollmentEntitlementBehavior, "REQUEST_CATALOG_UNENROLLMENT_ENTITLEMENT_BEHAVIOR_"] }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile" } }] } });
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceCreateRequest>): RequestCatalogManagementServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.description = "";
        message.published = false;
        message.visibleToEveryone = false;
        message.requestBundle = false;
        message.enrollmentBehavior = 0;
        message.unenrollmentBehavior = 0;
        message.unenrollmentEntitlementBehavior = 0;
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceCreateRequest): RequestCatalogManagementServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask */ 4:
                    message.expandMask = RequestCatalogExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* bool published */ 5:
                    message.published = reader.bool();
                    break;
                case /* bool visible_to_everyone */ 6:
                    message.visibleToEveryone = reader.bool();
                    break;
                case /* bool request_bundle */ 7:
                    message.requestBundle = reader.bool();
                    break;
                case /* c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior enrollment_behavior */ 8:
                    message.enrollmentBehavior = reader.int32();
                    break;
                case /* c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior unenrollment_behavior */ 9:
                    message.unenrollmentBehavior = reader.int32();
                    break;
                case /* c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior unenrollment_entitlement_behavior */ 10:
                    message.unenrollmentEntitlementBehavior = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 4; */
        if (message.expandMask)
            RequestCatalogExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool published = 5; */
        if (message.published !== false)
            writer.tag(5, WireType.Varint).bool(message.published);
        /* bool visible_to_everyone = 6; */
        if (message.visibleToEveryone !== false)
            writer.tag(6, WireType.Varint).bool(message.visibleToEveryone);
        /* bool request_bundle = 7; */
        if (message.requestBundle !== false)
            writer.tag(7, WireType.Varint).bool(message.requestBundle);
        /* c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior enrollment_behavior = 8; */
        if (message.enrollmentBehavior !== 0)
            writer.tag(8, WireType.Varint).int32(message.enrollmentBehavior);
        /* c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior unenrollment_behavior = 9; */
        if (message.unenrollmentBehavior !== 0)
            writer.tag(9, WireType.Varint).int32(message.unenrollmentBehavior);
        /* c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior unenrollment_entitlement_behavior = 10; */
        if (message.unenrollmentEntitlementBehavior !== 0)
            writer.tag(10, WireType.Varint).int32(message.unenrollmentEntitlementBehavior);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequest
 */
export const RequestCatalogManagementServiceCreateRequest = new RequestCatalogManagementServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceUpdateRequest$Type extends MessageType<RequestCatalogManagementServiceUpdateRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateRequest", [
            { no: 1, name: "catalog", kind: "message", T: () => RequestCatalog, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => RequestCatalogExpandMask }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceUpdateRequest>): RequestCatalogManagementServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceUpdateRequest): RequestCatalogManagementServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.requestcatalog.v1.RequestCatalog catalog */ 1:
                    message.catalog = RequestCatalog.internalBinaryRead(reader, reader.uint32(), options, message.catalog);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask */ 3:
                    message.expandMask = RequestCatalogExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.requestcatalog.v1.RequestCatalog catalog = 1; */
        if (message.catalog)
            RequestCatalog.internalBinaryWrite(message.catalog, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 3; */
        if (message.expandMask)
            RequestCatalogExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateRequest
 */
export const RequestCatalogManagementServiceUpdateRequest = new RequestCatalogManagementServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListRequest$Type extends MessageType<RequestCatalogManagementServiceListRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => RequestCatalogExpandMask }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceListRequest>): RequestCatalogManagementServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceListRequest): RequestCatalogManagementServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask */ 3:
                    message.expandMask = RequestCatalogExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 3; */
        if (message.expandMask)
            RequestCatalogExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListRequest
 */
export const RequestCatalogManagementServiceListRequest = new RequestCatalogManagementServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListResponse$Type extends MessageType<RequestCatalogManagementServiceListResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceListResponse>): RequestCatalogManagementServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceListResponse): RequestCatalogManagementServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.RequestCatalogView list */ 1:
                    message.list.push(RequestCatalogView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.RequestCatalogView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            RequestCatalogView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListResponse
 */
export const RequestCatalogManagementServiceListResponse = new RequestCatalogManagementServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceAddAppEntitlementsRequest$Type extends MessageType<RequestCatalogManagementServiceAddAppEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAppEntitlementsRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 3, name: "create_requests", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Requestable_Entries" } }] } });
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceAddAppEntitlementsRequest>): RequestCatalogManagementServiceAddAppEntitlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.appEntitlements = [];
        message.createRequests = false;
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceAddAppEntitlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceAddAppEntitlementsRequest): RequestCatalogManagementServiceAddAppEntitlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlements */ 2:
                    message.appEntitlements.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool create_requests */ 3:
                    message.createRequests = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceAddAppEntitlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 2; */
        for (let i = 0; i < message.appEntitlements.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlements[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool create_requests = 3; */
        if (message.createRequests !== false)
            writer.tag(3, WireType.Varint).bool(message.createRequests);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAppEntitlementsRequest
 */
export const RequestCatalogManagementServiceAddAppEntitlementsRequest = new RequestCatalogManagementServiceAddAppEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceAddAppEntitlementsResponse$Type extends MessageType<RequestCatalogManagementServiceAddAppEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAppEntitlementsResponse", []);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceAddAppEntitlementsResponse>): RequestCatalogManagementServiceAddAppEntitlementsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceAddAppEntitlementsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceAddAppEntitlementsResponse): RequestCatalogManagementServiceAddAppEntitlementsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceAddAppEntitlementsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAppEntitlementsResponse
 */
export const RequestCatalogManagementServiceAddAppEntitlementsResponse = new RequestCatalogManagementServiceAddAppEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceUpdateAppEntitlementsRequest$Type extends MessageType<RequestCatalogManagementServiceUpdateAppEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateAppEntitlementsRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Requestable_Entries" } }] } });
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceUpdateAppEntitlementsRequest>): RequestCatalogManagementServiceUpdateAppEntitlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.appEntitlements = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceUpdateAppEntitlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceUpdateAppEntitlementsRequest): RequestCatalogManagementServiceUpdateAppEntitlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlements */ 2:
                    message.appEntitlements.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceUpdateAppEntitlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 2; */
        for (let i = 0; i < message.appEntitlements.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlements[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateAppEntitlementsRequest
 */
export const RequestCatalogManagementServiceUpdateAppEntitlementsRequest = new RequestCatalogManagementServiceUpdateAppEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceUpdateAppEntitlementsResponse$Type extends MessageType<RequestCatalogManagementServiceUpdateAppEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateAppEntitlementsResponse", []);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceUpdateAppEntitlementsResponse>): RequestCatalogManagementServiceUpdateAppEntitlementsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceUpdateAppEntitlementsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceUpdateAppEntitlementsResponse): RequestCatalogManagementServiceUpdateAppEntitlementsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceUpdateAppEntitlementsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceUpdateAppEntitlementsResponse
 */
export const RequestCatalogManagementServiceUpdateAppEntitlementsResponse = new RequestCatalogManagementServiceUpdateAppEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceRemoveAppEntitlementsRequest$Type extends MessageType<RequestCatalogManagementServiceRemoveAppEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAppEntitlementsRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Requestable_Entries" } }] } });
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceRemoveAppEntitlementsRequest>): RequestCatalogManagementServiceRemoveAppEntitlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.appEntitlements = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceRemoveAppEntitlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceRemoveAppEntitlementsRequest): RequestCatalogManagementServiceRemoveAppEntitlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlements */ 2:
                    message.appEntitlements.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceRemoveAppEntitlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 2; */
        for (let i = 0; i < message.appEntitlements.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlements[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAppEntitlementsRequest
 */
export const RequestCatalogManagementServiceRemoveAppEntitlementsRequest = new RequestCatalogManagementServiceRemoveAppEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceRemoveAppEntitlementsResponse$Type extends MessageType<RequestCatalogManagementServiceRemoveAppEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAppEntitlementsResponse", []);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceRemoveAppEntitlementsResponse>): RequestCatalogManagementServiceRemoveAppEntitlementsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceRemoveAppEntitlementsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceRemoveAppEntitlementsResponse): RequestCatalogManagementServiceRemoveAppEntitlementsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceRemoveAppEntitlementsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAppEntitlementsResponse
 */
export const RequestCatalogManagementServiceRemoveAppEntitlementsResponse = new RequestCatalogManagementServiceRemoveAppEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceCreateRequestableEntryRequest$Type extends MessageType<RequestCatalogManagementServiceCreateRequestableEntryRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequestableEntryRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "create_requests", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Requestable_Entry" } }] } });
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceCreateRequestableEntryRequest>): RequestCatalogManagementServiceCreateRequestableEntryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.appId = "";
        message.entitlementId = "";
        message.createRequests = false;
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceCreateRequestableEntryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceCreateRequestableEntryRequest): RequestCatalogManagementServiceCreateRequestableEntryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 3:
                    message.entitlementId = reader.string();
                    break;
                case /* bool create_requests */ 4:
                    message.createRequests = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceCreateRequestableEntryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 3; */
        if (message.entitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementId);
        /* bool create_requests = 4; */
        if (message.createRequests !== false)
            writer.tag(4, WireType.Varint).bool(message.createRequests);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequestableEntryRequest
 */
export const RequestCatalogManagementServiceCreateRequestableEntryRequest = new RequestCatalogManagementServiceCreateRequestableEntryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestableEntry$Type extends MessageType<RequestableEntry> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestableEntry", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestableEntry>): RequestableEntry {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.appId = "";
        message.entitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestableEntry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestableEntry): RequestableEntry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 3:
                    message.entitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestableEntry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 3; */
        if (message.entitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestableEntry
 */
export const RequestableEntry = new RequestableEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceCreateRequestableEntryResponse$Type extends MessageType<RequestCatalogManagementServiceCreateRequestableEntryResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequestableEntryResponse", [
            { no: 1, name: "requestable_entry", kind: "message", T: () => RequestableEntry }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceCreateRequestableEntryResponse>): RequestCatalogManagementServiceCreateRequestableEntryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceCreateRequestableEntryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceCreateRequestableEntryResponse): RequestCatalogManagementServiceCreateRequestableEntryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.requestcatalog.v1.RequestableEntry requestable_entry */ 1:
                    message.requestableEntry = RequestableEntry.internalBinaryRead(reader, reader.uint32(), options, message.requestableEntry);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceCreateRequestableEntryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.requestcatalog.v1.RequestableEntry requestable_entry = 1; */
        if (message.requestableEntry)
            RequestableEntry.internalBinaryWrite(message.requestableEntry, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceCreateRequestableEntryResponse
 */
export const RequestCatalogManagementServiceCreateRequestableEntryResponse = new RequestCatalogManagementServiceCreateRequestableEntryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceGetRequestableEntryRequest$Type extends MessageType<RequestCatalogManagementServiceGetRequestableEntryRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequestableEntryRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Requestable_Entry" } }] } });
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceGetRequestableEntryRequest>): RequestCatalogManagementServiceGetRequestableEntryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.appId = "";
        message.entitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceGetRequestableEntryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceGetRequestableEntryRequest): RequestCatalogManagementServiceGetRequestableEntryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 3:
                    message.entitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceGetRequestableEntryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 3; */
        if (message.entitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequestableEntryRequest
 */
export const RequestCatalogManagementServiceGetRequestableEntryRequest = new RequestCatalogManagementServiceGetRequestableEntryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceGetRequestableEntryResponse$Type extends MessageType<RequestCatalogManagementServiceGetRequestableEntryResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequestableEntryResponse", [
            { no: 1, name: "requestable_entry", kind: "message", T: () => RequestableEntry }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceGetRequestableEntryResponse>): RequestCatalogManagementServiceGetRequestableEntryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceGetRequestableEntryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceGetRequestableEntryResponse): RequestCatalogManagementServiceGetRequestableEntryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.requestcatalog.v1.RequestableEntry requestable_entry */ 1:
                    message.requestableEntry = RequestableEntry.internalBinaryRead(reader, reader.uint32(), options, message.requestableEntry);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceGetRequestableEntryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.requestcatalog.v1.RequestableEntry requestable_entry = 1; */
        if (message.requestableEntry)
            RequestableEntry.internalBinaryWrite(message.requestableEntry, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceGetRequestableEntryResponse
 */
export const RequestCatalogManagementServiceGetRequestableEntryResponse = new RequestCatalogManagementServiceGetRequestableEntryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceDeleteRequestableEntryRequest$Type extends MessageType<RequestCatalogManagementServiceDeleteRequestableEntryRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequestableEntryRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Requestable_Entry" } }] } });
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceDeleteRequestableEntryRequest>): RequestCatalogManagementServiceDeleteRequestableEntryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.appId = "";
        message.entitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceDeleteRequestableEntryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceDeleteRequestableEntryRequest): RequestCatalogManagementServiceDeleteRequestableEntryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 3:
                    message.entitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceDeleteRequestableEntryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 3; */
        if (message.entitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequestableEntryRequest
 */
export const RequestCatalogManagementServiceDeleteRequestableEntryRequest = new RequestCatalogManagementServiceDeleteRequestableEntryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceDeleteRequestableEntryResponse$Type extends MessageType<RequestCatalogManagementServiceDeleteRequestableEntryResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequestableEntryResponse", []);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceDeleteRequestableEntryResponse>): RequestCatalogManagementServiceDeleteRequestableEntryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceDeleteRequestableEntryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceDeleteRequestableEntryResponse): RequestCatalogManagementServiceDeleteRequestableEntryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceDeleteRequestableEntryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequestableEntryResponse
 */
export const RequestCatalogManagementServiceDeleteRequestableEntryResponse = new RequestCatalogManagementServiceDeleteRequestableEntryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceAddAccessEntitlementsRequest$Type extends MessageType<RequestCatalogManagementServiceAddAccessEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAccessEntitlementsRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Visibility_Bindings" } }] } });
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceAddAccessEntitlementsRequest>): RequestCatalogManagementServiceAddAccessEntitlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.accessEntitlements = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceAddAccessEntitlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceAddAccessEntitlementsRequest): RequestCatalogManagementServiceAddAccessEntitlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef access_entitlements */ 2:
                    message.accessEntitlements.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceAddAccessEntitlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* repeated c1.api.app.v1.AppEntitlementRef access_entitlements = 2; */
        for (let i = 0; i < message.accessEntitlements.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.accessEntitlements[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAccessEntitlementsRequest
 */
export const RequestCatalogManagementServiceAddAccessEntitlementsRequest = new RequestCatalogManagementServiceAddAccessEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceAddAccessEntitlementsResponse$Type extends MessageType<RequestCatalogManagementServiceAddAccessEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAccessEntitlementsResponse", []);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceAddAccessEntitlementsResponse>): RequestCatalogManagementServiceAddAccessEntitlementsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceAddAccessEntitlementsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceAddAccessEntitlementsResponse): RequestCatalogManagementServiceAddAccessEntitlementsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceAddAccessEntitlementsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceAddAccessEntitlementsResponse
 */
export const RequestCatalogManagementServiceAddAccessEntitlementsResponse = new RequestCatalogManagementServiceAddAccessEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceRemoveAccessEntitlementsRequest$Type extends MessageType<RequestCatalogManagementServiceRemoveAccessEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAccessEntitlementsRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile_Visibility_Bindings" } }] } });
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceRemoveAccessEntitlementsRequest>): RequestCatalogManagementServiceRemoveAccessEntitlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.accessEntitlements = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceRemoveAccessEntitlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceRemoveAccessEntitlementsRequest): RequestCatalogManagementServiceRemoveAccessEntitlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef access_entitlements */ 2:
                    message.accessEntitlements.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceRemoveAccessEntitlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* repeated c1.api.app.v1.AppEntitlementRef access_entitlements = 2; */
        for (let i = 0; i < message.accessEntitlements.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.accessEntitlements[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAccessEntitlementsRequest
 */
export const RequestCatalogManagementServiceRemoveAccessEntitlementsRequest = new RequestCatalogManagementServiceRemoveAccessEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceRemoveAccessEntitlementsResponse$Type extends MessageType<RequestCatalogManagementServiceRemoveAccessEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAccessEntitlementsResponse", []);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceRemoveAccessEntitlementsResponse>): RequestCatalogManagementServiceRemoveAccessEntitlementsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceRemoveAccessEntitlementsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceRemoveAccessEntitlementsResponse): RequestCatalogManagementServiceRemoveAccessEntitlementsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceRemoveAccessEntitlementsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceRemoveAccessEntitlementsResponse
 */
export const RequestCatalogManagementServiceRemoveAccessEntitlementsResponse = new RequestCatalogManagementServiceRemoveAccessEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListEntitlementsPerCatalogRequest$Type extends MessageType<RequestCatalogManagementServiceListEntitlementsPerCatalogRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerCatalogRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceListEntitlementsPerCatalogRequest>): RequestCatalogManagementServiceListEntitlementsPerCatalogRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceListEntitlementsPerCatalogRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceListEntitlementsPerCatalogRequest): RequestCatalogManagementServiceListEntitlementsPerCatalogRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 4:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceListEntitlementsPerCatalogRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerCatalogRequest
 */
export const RequestCatalogManagementServiceListEntitlementsPerCatalogRequest = new RequestCatalogManagementServiceListEntitlementsPerCatalogRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListEntitlementsPerCatalogResponse$Type extends MessageType<RequestCatalogManagementServiceListEntitlementsPerCatalogResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerCatalogResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceListEntitlementsPerCatalogResponse>): RequestCatalogManagementServiceListEntitlementsPerCatalogResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceListEntitlementsPerCatalogResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceListEntitlementsPerCatalogResponse): RequestCatalogManagementServiceListEntitlementsPerCatalogResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementView list */ 1:
                    message.list.push(AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceListEntitlementsPerCatalogResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerCatalogResponse
 */
export const RequestCatalogManagementServiceListEntitlementsPerCatalogResponse = new RequestCatalogManagementServiceListEntitlementsPerCatalogResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest$Type extends MessageType<RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest>): RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest): RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest
 */
export const RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest = new RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse$Type extends MessageType<RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse", [
            { no: 1, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse>): RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse): RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef refs */ 1:
                    message.refs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef refs = 1; */
        for (let i = 0; i < message.refs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.refs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse
 */
export const RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse = new RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListEntitlementsPerAppRequest$Type extends MessageType<RequestCatalogManagementServiceListEntitlementsPerAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerAppRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceListEntitlementsPerAppRequest>): RequestCatalogManagementServiceListEntitlementsPerAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.appId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceListEntitlementsPerAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceListEntitlementsPerAppRequest): RequestCatalogManagementServiceListEntitlementsPerAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceListEntitlementsPerAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerAppRequest
 */
export const RequestCatalogManagementServiceListEntitlementsPerAppRequest = new RequestCatalogManagementServiceListEntitlementsPerAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListEntitlementsPerAppResponse$Type extends MessageType<RequestCatalogManagementServiceListEntitlementsPerAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceListEntitlementsPerAppResponse>): RequestCatalogManagementServiceListEntitlementsPerAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceListEntitlementsPerAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceListEntitlementsPerAppResponse): RequestCatalogManagementServiceListEntitlementsPerAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementView list */ 1:
                    message.list.push(AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceListEntitlementsPerAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsPerAppResponse
 */
export const RequestCatalogManagementServiceListEntitlementsPerAppResponse = new RequestCatalogManagementServiceListEntitlementsPerAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListEntitlementsForAccessRequest$Type extends MessageType<RequestCatalogManagementServiceListEntitlementsForAccessRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsForAccessRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceListEntitlementsForAccessRequest>): RequestCatalogManagementServiceListEntitlementsForAccessRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceListEntitlementsForAccessRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceListEntitlementsForAccessRequest): RequestCatalogManagementServiceListEntitlementsForAccessRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 4:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceListEntitlementsForAccessRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsForAccessRequest
 */
export const RequestCatalogManagementServiceListEntitlementsForAccessRequest = new RequestCatalogManagementServiceListEntitlementsForAccessRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceListEntitlementsForAccessResponse$Type extends MessageType<RequestCatalogManagementServiceListEntitlementsForAccessResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsForAccessResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceListEntitlementsForAccessResponse>): RequestCatalogManagementServiceListEntitlementsForAccessResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceListEntitlementsForAccessResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceListEntitlementsForAccessResponse): RequestCatalogManagementServiceListEntitlementsForAccessResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementView list */ 1:
                    message.list.push(AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceListEntitlementsForAccessResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceListEntitlementsForAccessResponse
 */
export const RequestCatalogManagementServiceListEntitlementsForAccessResponse = new RequestCatalogManagementServiceListEntitlementsForAccessResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceDeleteRequest$Type extends MessageType<RequestCatalogManagementServiceDeleteRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile" } }] } });
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceDeleteRequest>): RequestCatalogManagementServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceDeleteRequest): RequestCatalogManagementServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteRequest
 */
export const RequestCatalogManagementServiceDeleteRequest = new RequestCatalogManagementServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogManagementServiceDeleteResponse$Type extends MessageType<RequestCatalogManagementServiceDeleteResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<RequestCatalogManagementServiceDeleteResponse>): RequestCatalogManagementServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogManagementServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogManagementServiceDeleteResponse): RequestCatalogManagementServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogManagementServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogManagementServiceDeleteResponse
 */
export const RequestCatalogManagementServiceDeleteResponse = new RequestCatalogManagementServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnerExpandMask$Type extends MessageType<RequestCatalogOwnerExpandMask> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnerExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogOwnerExpandMask>): RequestCatalogOwnerExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogOwnerExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogOwnerExpandMask): RequestCatalogOwnerExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogOwnerExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnerExpandMask
 */
export const RequestCatalogOwnerExpandMask = new RequestCatalogOwnerExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnersServiceListRequest$Type extends MessageType<RequestCatalogOwnersServiceListRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnersServiceListRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => RequestCatalogOwnerExpandMask }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogOwnersServiceListRequest>): RequestCatalogOwnersServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogOwnersServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogOwnersServiceListRequest): RequestCatalogOwnersServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.requestcatalog.v1.RequestCatalogOwnerExpandMask expand_mask */ 4:
                    message.expandMask = RequestCatalogOwnerExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogOwnersServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.requestcatalog.v1.RequestCatalogOwnerExpandMask expand_mask = 4; */
        if (message.expandMask)
            RequestCatalogOwnerExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceListRequest
 */
export const RequestCatalogOwnersServiceListRequest = new RequestCatalogOwnersServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwner$Type extends MessageType<RequestCatalogOwner> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwner", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogOwner>): RequestCatalogOwner {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogOwner>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogOwner): RequestCatalogOwner {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogOwner, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwner
 */
export const RequestCatalogOwner = new RequestCatalogOwner$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnerView$Type extends MessageType<RequestCatalogOwnerView> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnerView", [
            { no: 1, name: "request_catalog_owner", kind: "message", T: () => RequestCatalogOwner },
            { no: 2, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogOwnerView>): RequestCatalogOwnerView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userPath = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogOwnerView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogOwnerView): RequestCatalogOwnerView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.requestcatalog.v1.RequestCatalogOwner request_catalog_owner */ 1:
                    message.requestCatalogOwner = RequestCatalogOwner.internalBinaryRead(reader, reader.uint32(), options, message.requestCatalogOwner);
                    break;
                case /* string user_path */ 2:
                    message.userPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogOwnerView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.requestcatalog.v1.RequestCatalogOwner request_catalog_owner = 1; */
        if (message.requestCatalogOwner)
            RequestCatalogOwner.internalBinaryWrite(message.requestCatalogOwner, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string user_path = 2; */
        if (message.userPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnerView
 */
export const RequestCatalogOwnerView = new RequestCatalogOwnerView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnersServiceListResponse$Type extends MessageType<RequestCatalogOwnersServiceListResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnersServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogOwnerView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogOwnersServiceListResponse>): RequestCatalogOwnersServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogOwnersServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogOwnersServiceListResponse): RequestCatalogOwnersServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.RequestCatalogOwnerView list */ 1:
                    message.list.push(RequestCatalogOwnerView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogOwnersServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.RequestCatalogOwnerView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            RequestCatalogOwnerView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceListResponse
 */
export const RequestCatalogOwnersServiceListResponse = new RequestCatalogOwnersServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnersServiceAddRequest$Type extends MessageType<RequestCatalogOwnersServiceAddRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnersServiceAddRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogOwnersServiceAddRequest>): RequestCatalogOwnersServiceAddRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestCatalogId = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogOwnersServiceAddRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogOwnersServiceAddRequest): RequestCatalogOwnersServiceAddRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_catalog_id */ 1:
                    message.requestCatalogId = reader.string();
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogOwnersServiceAddRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_catalog_id = 1; */
        if (message.requestCatalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestCatalogId);
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceAddRequest
 */
export const RequestCatalogOwnersServiceAddRequest = new RequestCatalogOwnersServiceAddRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnersServiceAddResponse$Type extends MessageType<RequestCatalogOwnersServiceAddResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnersServiceAddResponse", [
            { no: 1, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogOwnersServiceAddResponse>): RequestCatalogOwnersServiceAddResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogOwnersServiceAddResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogOwnersServiceAddResponse): RequestCatalogOwnersServiceAddResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogOwnersServiceAddResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceAddResponse
 */
export const RequestCatalogOwnersServiceAddResponse = new RequestCatalogOwnersServiceAddResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnersServiceRemoveRequest$Type extends MessageType<RequestCatalogOwnersServiceRemoveRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnersServiceRemoveRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogOwnersServiceRemoveRequest>): RequestCatalogOwnersServiceRemoveRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestCatalogId = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogOwnersServiceRemoveRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogOwnersServiceRemoveRequest): RequestCatalogOwnersServiceRemoveRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_catalog_id */ 1:
                    message.requestCatalogId = reader.string();
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogOwnersServiceRemoveRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_catalog_id = 1; */
        if (message.requestCatalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestCatalogId);
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceRemoveRequest
 */
export const RequestCatalogOwnersServiceRemoveRequest = new RequestCatalogOwnersServiceRemoveRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogOwnersServiceRemoveResponse$Type extends MessageType<RequestCatalogOwnersServiceRemoveResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogOwnersServiceRemoveResponse", []);
    }
    create(value?: PartialMessage<RequestCatalogOwnersServiceRemoveResponse>): RequestCatalogOwnersServiceRemoveResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogOwnersServiceRemoveResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogOwnersServiceRemoveResponse): RequestCatalogOwnersServiceRemoveResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogOwnersServiceRemoveResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogOwnersServiceRemoveResponse
 */
export const RequestCatalogOwnersServiceRemoveResponse = new RequestCatalogOwnersServiceRemoveResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogRef$Type extends MessageType<RequestCatalogRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogRef>): RequestCatalogRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogRef): RequestCatalogRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogRef
 */
export const RequestCatalogRef = new RequestCatalogRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAutomationLastRunState$Type extends MessageType<BundleAutomationLastRunState> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAutomationLastRunState", [
            { no: 1, name: "last_run_at", kind: "message", T: () => Timestamp },
            { no: 2, name: "status", kind: "enum", T: () => ["c1.api.requestcatalog.v1.BundleAutomationRunStatus", BundleAutomationRunStatus, "BUNDLE_AUTOMATION_RUN_STATUS_"] },
            { no: 3, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BundleAutomationLastRunState>): BundleAutomationLastRunState {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<BundleAutomationLastRunState>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BundleAutomationLastRunState): BundleAutomationLastRunState {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp last_run_at */ 1:
                    message.lastRunAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastRunAt);
                    break;
                case /* c1.api.requestcatalog.v1.BundleAutomationRunStatus status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string error_message */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BundleAutomationLastRunState, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp last_run_at = 1; */
        if (message.lastRunAt)
            Timestamp.internalBinaryWrite(message.lastRunAt, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.requestcatalog.v1.BundleAutomationRunStatus status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string error_message = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAutomationLastRunState
 */
export const BundleAutomationLastRunState = new BundleAutomationLastRunState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAutomationRuleEntitlement$Type extends MessageType<BundleAutomationRuleEntitlement> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement", [
            { no: 1, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<BundleAutomationRuleEntitlement>): BundleAutomationRuleEntitlement {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entitlementRefs = [];
        if (value !== undefined)
            reflectionMergePartial<BundleAutomationRuleEntitlement>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BundleAutomationRuleEntitlement): BundleAutomationRuleEntitlement {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs */ 1:
                    message.entitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BundleAutomationRuleEntitlement, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 1; */
        for (let i = 0; i < message.entitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRefs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement
 */
export const BundleAutomationRuleEntitlement = new BundleAutomationRuleEntitlement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBundleAutomationRequest$Type extends MessageType<SetBundleAutomationRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SetBundleAutomationRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 101, name: "entitlements", kind: "message", oneof: "conditions", T: () => BundleAutomationRuleEntitlement },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "create_tasks", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "disable_circuit_breaker", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SetBundleAutomationRequest>): SetBundleAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestCatalogId = "";
        message.conditions = { oneofKind: undefined };
        message.enabled = false;
        message.createTasks = false;
        message.disableCircuitBreaker = false;
        if (value !== undefined)
            reflectionMergePartial<SetBundleAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetBundleAutomationRequest): SetBundleAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_catalog_id */ 1:
                    message.requestCatalogId = reader.string();
                    break;
                case /* c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement entitlements */ 101:
                    message.conditions = {
                        oneofKind: "entitlements",
                        entitlements: BundleAutomationRuleEntitlement.internalBinaryRead(reader, reader.uint32(), options, (message.conditions as any).entitlements)
                    };
                    break;
                case /* bool enabled */ 2:
                    message.enabled = reader.bool();
                    break;
                case /* bool create_tasks */ 3:
                    message.createTasks = reader.bool();
                    break;
                case /* bool disable_circuit_breaker */ 4:
                    message.disableCircuitBreaker = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetBundleAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_catalog_id = 1; */
        if (message.requestCatalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestCatalogId);
        /* bool enabled = 2; */
        if (message.enabled !== false)
            writer.tag(2, WireType.Varint).bool(message.enabled);
        /* bool create_tasks = 3; */
        if (message.createTasks !== false)
            writer.tag(3, WireType.Varint).bool(message.createTasks);
        /* bool disable_circuit_breaker = 4; */
        if (message.disableCircuitBreaker !== false)
            writer.tag(4, WireType.Varint).bool(message.disableCircuitBreaker);
        /* c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement entitlements = 101; */
        if (message.conditions.oneofKind === "entitlements")
            BundleAutomationRuleEntitlement.internalBinaryWrite(message.conditions.entitlements, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SetBundleAutomationRequest
 */
export const SetBundleAutomationRequest = new SetBundleAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAutomationRef$Type extends MessageType<BundleAutomationRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAutomationRef", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<BundleAutomationRef>): BundleAutomationRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestCatalogId = "";
        if (value !== undefined)
            reflectionMergePartial<BundleAutomationRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BundleAutomationRef): BundleAutomationRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_catalog_id */ 1:
                    message.requestCatalogId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BundleAutomationRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_catalog_id = 1; */
        if (message.requestCatalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestCatalogId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAutomationRef
 */
export const BundleAutomationRef = new BundleAutomationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAutomationCircuitBreaker$Type extends MessageType<BundleAutomationCircuitBreaker> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAutomationCircuitBreaker", [
            { no: 1, name: "state", kind: "enum", T: () => ["c1.api.requestcatalog.v1.BundleAutomationCircuitBreakerState", BundleAutomationCircuitBreakerState] },
            { no: 2, name: "user_ref", kind: "message", T: () => UserRef },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "removed_members_threshold_percentage", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<BundleAutomationCircuitBreaker>): BundleAutomationCircuitBreaker {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.state = 0;
        message.removedMembersThresholdPercentage = 0;
        if (value !== undefined)
            reflectionMergePartial<BundleAutomationCircuitBreaker>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BundleAutomationCircuitBreaker): BundleAutomationCircuitBreaker {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.requestcatalog.v1.BundleAutomationCircuitBreakerState state */ 1:
                    message.state = reader.int32();
                    break;
                case /* c1.api.user.v1.UserRef user_ref */ 2:
                    message.userRef = UserRef.internalBinaryRead(reader, reader.uint32(), options, message.userRef);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* int64 removed_members_threshold_percentage */ 4:
                    message.removedMembersThresholdPercentage = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BundleAutomationCircuitBreaker, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.requestcatalog.v1.BundleAutomationCircuitBreakerState state = 1; */
        if (message.state !== 0)
            writer.tag(1, WireType.Varint).int32(message.state);
        /* c1.api.user.v1.UserRef user_ref = 2; */
        if (message.userRef)
            UserRef.internalBinaryWrite(message.userRef, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int64 removed_members_threshold_percentage = 4; */
        if (message.removedMembersThresholdPercentage !== 0)
            writer.tag(4, WireType.Varint).int64(message.removedMembersThresholdPercentage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAutomationCircuitBreaker
 */
export const BundleAutomationCircuitBreaker = new BundleAutomationCircuitBreaker$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAutomation$Type extends MessageType<BundleAutomation> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAutomation", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "state", kind: "message", T: () => BundleAutomationLastRunState },
            { no: 101, name: "entitlements", kind: "message", oneof: "conditions", T: () => BundleAutomationRuleEntitlement },
            { no: 7, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "create_tasks", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "circuit_breaker", kind: "message", T: () => BundleAutomationCircuitBreaker },
            { no: 10, name: "disable_circuit_breaker", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BundleAutomation>): BundleAutomation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.requestCatalogId = "";
        message.conditions = { oneofKind: undefined };
        message.enabled = false;
        message.createTasks = false;
        message.disableCircuitBreaker = false;
        if (value !== undefined)
            reflectionMergePartial<BundleAutomation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BundleAutomation): BundleAutomation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string request_catalog_id */ 2:
                    message.requestCatalogId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* c1.api.requestcatalog.v1.BundleAutomationLastRunState state */ 6:
                    message.state = BundleAutomationLastRunState.internalBinaryRead(reader, reader.uint32(), options, message.state);
                    break;
                case /* c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement entitlements */ 101:
                    message.conditions = {
                        oneofKind: "entitlements",
                        entitlements: BundleAutomationRuleEntitlement.internalBinaryRead(reader, reader.uint32(), options, (message.conditions as any).entitlements)
                    };
                    break;
                case /* bool enabled */ 7:
                    message.enabled = reader.bool();
                    break;
                case /* bool create_tasks */ 8:
                    message.createTasks = reader.bool();
                    break;
                case /* c1.api.requestcatalog.v1.BundleAutomationCircuitBreaker circuit_breaker */ 9:
                    message.circuitBreaker = BundleAutomationCircuitBreaker.internalBinaryRead(reader, reader.uint32(), options, message.circuitBreaker);
                    break;
                case /* bool disable_circuit_breaker */ 10:
                    message.disableCircuitBreaker = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BundleAutomation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string request_catalog_id = 2; */
        if (message.requestCatalogId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requestCatalogId);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.requestcatalog.v1.BundleAutomationLastRunState state = 6; */
        if (message.state)
            BundleAutomationLastRunState.internalBinaryWrite(message.state, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool enabled = 7; */
        if (message.enabled !== false)
            writer.tag(7, WireType.Varint).bool(message.enabled);
        /* bool create_tasks = 8; */
        if (message.createTasks !== false)
            writer.tag(8, WireType.Varint).bool(message.createTasks);
        /* c1.api.requestcatalog.v1.BundleAutomationCircuitBreaker circuit_breaker = 9; */
        if (message.circuitBreaker)
            BundleAutomationCircuitBreaker.internalBinaryWrite(message.circuitBreaker, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bool disable_circuit_breaker = 10; */
        if (message.disableCircuitBreaker !== false)
            writer.tag(10, WireType.Varint).bool(message.disableCircuitBreaker);
        /* c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement entitlements = 101; */
        if (message.conditions.oneofKind === "entitlements")
            BundleAutomationRuleEntitlement.internalBinaryWrite(message.conditions.entitlements, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAutomation
 */
export const BundleAutomation = new BundleAutomation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBundleAutomationRequest$Type extends MessageType<GetBundleAutomationRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.GetBundleAutomationRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetBundleAutomationRequest>): GetBundleAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestCatalogId = "";
        if (value !== undefined)
            reflectionMergePartial<GetBundleAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBundleAutomationRequest): GetBundleAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_catalog_id */ 1:
                    message.requestCatalogId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBundleAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_catalog_id = 1; */
        if (message.requestCatalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestCatalogId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.GetBundleAutomationRequest
 */
export const GetBundleAutomationRequest = new GetBundleAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetBundleAutomationsRequest$Type extends MessageType<BulkGetBundleAutomationsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.BulkGetBundleAutomationsRequest", [
            { no: 1, name: "request_catalog_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
    create(value?: PartialMessage<BulkGetBundleAutomationsRequest>): BulkGetBundleAutomationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestCatalogRefs = [];
        if (value !== undefined)
            reflectionMergePartial<BulkGetBundleAutomationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGetBundleAutomationsRequest): BulkGetBundleAutomationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.RequestCatalogRef request_catalog_refs */ 1:
                    message.requestCatalogRefs.push(RequestCatalogRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGetBundleAutomationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.RequestCatalogRef request_catalog_refs = 1; */
        for (let i = 0; i < message.requestCatalogRefs.length; i++)
            RequestCatalogRef.internalBinaryWrite(message.requestCatalogRefs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BulkGetBundleAutomationsRequest
 */
export const BulkGetBundleAutomationsRequest = new BulkGetBundleAutomationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetBundleAutomationsResponse$Type extends MessageType<BulkGetBundleAutomationsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.BulkGetBundleAutomationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BundleAutomation }
        ]);
    }
    create(value?: PartialMessage<BulkGetBundleAutomationsResponse>): BulkGetBundleAutomationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<BulkGetBundleAutomationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGetBundleAutomationsResponse): BulkGetBundleAutomationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.BundleAutomation list */ 1:
                    message.list.push(BundleAutomation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGetBundleAutomationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.BundleAutomation list = 1; */
        for (let i = 0; i < message.list.length; i++)
            BundleAutomation.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BulkGetBundleAutomationsResponse
 */
export const BulkGetBundleAutomationsResponse = new BulkGetBundleAutomationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForceRunBundleAutomationRequest$Type extends MessageType<ForceRunBundleAutomationRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.ForceRunBundleAutomationRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<ForceRunBundleAutomationRequest>): ForceRunBundleAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestCatalogId = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<ForceRunBundleAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ForceRunBundleAutomationRequest): ForceRunBundleAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_catalog_id */ 1:
                    message.requestCatalogId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef refs */ 2:
                    message.refs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ForceRunBundleAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_catalog_id = 1; */
        if (message.requestCatalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestCatalogId);
        /* repeated c1.api.app.v1.AppEntitlementRef refs = 2; */
        for (let i = 0; i < message.refs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.refs[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.ForceRunBundleAutomationRequest
 */
export const ForceRunBundleAutomationRequest = new ForceRunBundleAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForceRunBundleAutomationResponse$Type extends MessageType<ForceRunBundleAutomationResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.ForceRunBundleAutomationResponse", []);
    }
    create(value?: PartialMessage<ForceRunBundleAutomationResponse>): ForceRunBundleAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ForceRunBundleAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ForceRunBundleAutomationResponse): ForceRunBundleAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ForceRunBundleAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.ForceRunBundleAutomationResponse
 */
export const ForceRunBundleAutomationResponse = new ForceRunBundleAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResumePausedBundleAutomationRequest$Type extends MessageType<ResumePausedBundleAutomationRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.ResumePausedBundleAutomationRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ResumePausedBundleAutomationRequest>): ResumePausedBundleAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestCatalogId = "";
        if (value !== undefined)
            reflectionMergePartial<ResumePausedBundleAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResumePausedBundleAutomationRequest): ResumePausedBundleAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_catalog_id */ 1:
                    message.requestCatalogId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResumePausedBundleAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_catalog_id = 1; */
        if (message.requestCatalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestCatalogId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.ResumePausedBundleAutomationRequest
 */
export const ResumePausedBundleAutomationRequest = new ResumePausedBundleAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResumePausedBundleAutomationResponse$Type extends MessageType<ResumePausedBundleAutomationResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.ResumePausedBundleAutomationResponse", []);
    }
    create(value?: PartialMessage<ResumePausedBundleAutomationResponse>): ResumePausedBundleAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ResumePausedBundleAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResumePausedBundleAutomationResponse): ResumePausedBundleAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResumePausedBundleAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.ResumePausedBundleAutomationResponse
 */
export const ResumePausedBundleAutomationResponse = new ResumePausedBundleAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBundleAutomationRequest$Type extends MessageType<DeleteBundleAutomationRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.DeleteBundleAutomationRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteBundleAutomationRequest>): DeleteBundleAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestCatalogId = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteBundleAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteBundleAutomationRequest): DeleteBundleAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_catalog_id */ 1:
                    message.requestCatalogId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteBundleAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_catalog_id = 1; */
        if (message.requestCatalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestCatalogId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.DeleteBundleAutomationRequest
 */
export const DeleteBundleAutomationRequest = new DeleteBundleAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBundleAutomationResponse$Type extends MessageType<DeleteBundleAutomationResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.DeleteBundleAutomationResponse", []);
    }
    create(value?: PartialMessage<DeleteBundleAutomationResponse>): DeleteBundleAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteBundleAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteBundleAutomationResponse): DeleteBundleAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteBundleAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.DeleteBundleAutomationResponse
 */
export const DeleteBundleAutomationResponse = new DeleteBundleAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBundleAutomationRequest$Type extends MessageType<CreateBundleAutomationRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.CreateBundleAutomationRequest", [
            { no: 1, name: "request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 101, name: "entitlements", kind: "message", oneof: "conditions", T: () => BundleAutomationRuleEntitlement },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "create_tasks", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "disable_circuit_breaker", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateBundleAutomationRequest>): CreateBundleAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestCatalogId = "";
        message.conditions = { oneofKind: undefined };
        message.enabled = false;
        message.createTasks = false;
        message.disableCircuitBreaker = false;
        if (value !== undefined)
            reflectionMergePartial<CreateBundleAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateBundleAutomationRequest): CreateBundleAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string request_catalog_id */ 1:
                    message.requestCatalogId = reader.string();
                    break;
                case /* c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement entitlements */ 101:
                    message.conditions = {
                        oneofKind: "entitlements",
                        entitlements: BundleAutomationRuleEntitlement.internalBinaryRead(reader, reader.uint32(), options, (message.conditions as any).entitlements)
                    };
                    break;
                case /* bool enabled */ 3:
                    message.enabled = reader.bool();
                    break;
                case /* bool create_tasks */ 4:
                    message.createTasks = reader.bool();
                    break;
                case /* bool disable_circuit_breaker */ 5:
                    message.disableCircuitBreaker = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateBundleAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string request_catalog_id = 1; */
        if (message.requestCatalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestCatalogId);
        /* bool enabled = 3; */
        if (message.enabled !== false)
            writer.tag(3, WireType.Varint).bool(message.enabled);
        /* bool create_tasks = 4; */
        if (message.createTasks !== false)
            writer.tag(4, WireType.Varint).bool(message.createTasks);
        /* bool disable_circuit_breaker = 5; */
        if (message.disableCircuitBreaker !== false)
            writer.tag(5, WireType.Varint).bool(message.disableCircuitBreaker);
        /* c1.api.requestcatalog.v1.BundleAutomationRuleEntitlement entitlements = 101; */
        if (message.conditions.oneofKind === "entitlements")
            BundleAutomationRuleEntitlement.internalBinaryWrite(message.conditions.entitlements, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.CreateBundleAutomationRequest
 */
export const CreateBundleAutomationRequest = new CreateBundleAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppDefaultCatalogRequest$Type extends MessageType<CreateAppDefaultCatalogRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.CreateAppDefaultCatalogRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "published", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "visible_to_everyone", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "expand_mask", kind: "message", T: () => RequestCatalogExpandMask }
        ]);
    }
    create(value?: PartialMessage<CreateAppDefaultCatalogRequest>): CreateAppDefaultCatalogRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.published = false;
        message.visibleToEveryone = false;
        if (value !== undefined)
            reflectionMergePartial<CreateAppDefaultCatalogRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAppDefaultCatalogRequest): CreateAppDefaultCatalogRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* bool published */ 5:
                    message.published = reader.bool();
                    break;
                case /* bool visible_to_everyone */ 6:
                    message.visibleToEveryone = reader.bool();
                    break;
                case /* c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask */ 2:
                    message.expandMask = RequestCatalogExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAppDefaultCatalogRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* c1.api.requestcatalog.v1.RequestCatalogExpandMask expand_mask = 2; */
        if (message.expandMask)
            RequestCatalogExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool published = 5; */
        if (message.published !== false)
            writer.tag(5, WireType.Varint).bool(message.published);
        /* bool visible_to_everyone = 6; */
        if (message.visibleToEveryone !== false)
            writer.tag(6, WireType.Varint).bool(message.visibleToEveryone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.CreateAppDefaultCatalogRequest
 */
export const CreateAppDefaultCatalogRequest = new CreateAppDefaultCatalogRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.requestcatalog.v1.RequestCatalogManagementService
 */
export const RequestCatalogManagementService = new ServiceType("c1.api.requestcatalog.v1.RequestCatalogManagementService", [
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access_Profile" }], group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceGetRequest, O: RequestCatalogManagementServiceGetResponse },
    { name: "Create", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access_Profile" }], group: "Request Catalog" }] }, "authz.method": { role: "EDITOR" } }, I: RequestCatalogManagementServiceCreateRequest, O: RequestCatalogManagementServiceGetResponse },
    { name: "Update", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{catalog.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Access_Profile" }], group: "Request Catalog" }] }, "authz.method": { role: "EDITOR" } }, I: RequestCatalogManagementServiceUpdateRequest, O: RequestCatalogManagementServiceGetResponse },
    { name: "List", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Request Catalogs", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceListRequest, O: RequestCatalogManagementServiceListResponse },
    { name: "AddAppEntitlements", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{catalog_id}/requestable_entries", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access_Profile_Requestable_Entries" }], group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceAddAppEntitlementsRequest, O: RequestCatalogManagementServiceAddAppEntitlementsResponse },
    { name: "RemoveAppEntitlements", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/catalogs/{catalog_id}/requestable_entries", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access_Profile_Requestable_Entries" }], group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceRemoveAppEntitlementsRequest, O: RequestCatalogManagementServiceRemoveAppEntitlementsResponse },
    { name: "CreateRequestableEntry", options: { "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/catalogs/{catalog_id}/requestable_entries/{app_id}/{entitlement_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access_Profile_Requestable_Entry" }], group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceCreateRequestableEntryRequest, O: RequestCatalogManagementServiceCreateRequestableEntryResponse },
    { name: "GetRequestableEntry", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs/{catalog_id}/requestable_entries/{app_id}/{entitlement_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access_Profile_Requestable_Entry", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceGetRequestableEntryRequest, O: RequestCatalogManagementServiceGetRequestableEntryResponse },
    { name: "DeleteRequestableEntry", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/catalogs/{catalog_id}/requestable_entries/{app_id}/{entitlement_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access_Profile_Requestable_Entry" }], group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceDeleteRequestableEntryRequest, O: RequestCatalogManagementServiceDeleteRequestableEntryResponse },
    { name: "AddAccessEntitlements", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{catalog_id}/visibility_bindings", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access_Profile_Visibility_Bindings" }], group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceAddAccessEntitlementsRequest, O: RequestCatalogManagementServiceAddAccessEntitlementsResponse },
    { name: "RemoveAccessEntitlements", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/catalogs/{catalog_id}/visibility_bindings", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access_Profile_Visibility_Bindings" }], group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceRemoveAccessEntitlementsRequest, O: RequestCatalogManagementServiceRemoveAccessEntitlementsResponse },
    { name: "ListEntitlementsPerCatalog", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs/{catalog_id}/requestable_entitlements", query: { page_size: "page_size", page_token: "page_token" }, group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceListEntitlementsPerCatalogRequest, O: RequestCatalogManagementServiceListEntitlementsPerCatalogResponse },
    { name: "ListEntitlementsPerApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceListEntitlementsPerAppRequest, O: RequestCatalogManagementServiceListEntitlementsPerAppResponse },
    { name: "ListAllEntitlementIdsPerApp", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs/{catalog_id}/requestable_entitlementIDs", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access_Profile_Requestable_Entries", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogRequest, O: RequestCatalogManagementServiceListAllEntitlementIdsPerCatalogResponse },
    { name: "UpdateAppEntitlements", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{catalog_id}/requestable_entitlements/update", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Access_Profile_Requestable_Entries" }], group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceUpdateAppEntitlementsRequest, O: RequestCatalogManagementServiceUpdateAppEntitlementsResponse },
    { name: "ListEntitlementsForAccess", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs/{catalog_id}/visibility_entitlements", query: { page_size: "page_size", page_token: "page_token" }, group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogManagementServiceListEntitlementsForAccessRequest, O: RequestCatalogManagementServiceListEntitlementsForAccessResponse },
    { name: "Delete", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/catalogs/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access_Profile" }], group: "Request Catalog" }] }, "authz.method": { role: "OWNER" } }, I: RequestCatalogManagementServiceDeleteRequest, O: RequestCatalogManagementServiceDeleteResponse },
    { name: "GetBundleAutomation", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/catalogs/{request_catalog_id}/bundle_automation", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "BundleAutomation" }], group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: GetBundleAutomationRequest, O: BundleAutomation },
    { name: "BulkGetBundleAutomations", options: { "authz.method": { role: "VIEWER" } }, I: BulkGetBundleAutomationsRequest, O: BulkGetBundleAutomationsResponse },
    { name: "SetBundleAutomation", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{request_catalog_id}/bundle_automation", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "BundleAutomation" }], group: "Request Catalog" }] }, "authz.method": { role: "EDITOR" } }, I: SetBundleAutomationRequest, O: BundleAutomation },
    { name: "ForceRunBundleAutomation", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{request_catalog_id}/bundle_automation/run", group: "Request Catalog" }] }, "authz.method": { role: "EDITOR" } }, I: ForceRunBundleAutomationRequest, O: ForceRunBundleAutomationResponse },
    { name: "ResumePausedBundleAutomation", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{request_catalog_id}/bundle_automation/resume", group: "Request Catalog" }] }, "authz.method": { role: "EDITOR" } }, I: ResumePausedBundleAutomationRequest, O: ResumePausedBundleAutomationResponse },
    { name: "CreateBundleAutomation", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/catalogs/{request_catalog_id}/bundle_automation/create", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "BundleAutomation" }], group: "Request Catalog" }] }, "authz.method": { role: "EDITOR" } }, I: CreateBundleAutomationRequest, O: BundleAutomation },
    { name: "DeleteBundleAutomation", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/catalogs/{request_catalog_id}/bundle_automation", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "BundleAutomation" }], group: "Request Catalog" }] }, "authz.method": { role: "EDITOR" } }, I: DeleteBundleAutomationRequest, O: DeleteBundleAutomationResponse },
    { name: "CreateAppDefaultCatalog", options: { "authz.method": { role: "VIEWER" } }, I: CreateAppDefaultCatalogRequest, O: RequestCatalogManagementServiceGetResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.requestcatalog.v1.RequestCatalogOwnersService
 */
export const RequestCatalogOwnersService = new ServiceType("c1.api.requestcatalog.v1.RequestCatalogOwnersService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogOwnersServiceListRequest, O: RequestCatalogOwnersServiceListResponse },
    { name: "Add", options: { "authz.method": { role: "EDITOR" } }, I: RequestCatalogOwnersServiceAddRequest, O: RequestCatalogOwnersServiceAddResponse },
    { name: "Remove", options: { "authz.method": { role: "EDITOR" } }, I: RequestCatalogOwnersServiceRemoveRequest, O: RequestCatalogOwnersServiceRemoveResponse }
]);
